// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/common/v1/primitives.proto (package thru.common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/common/v1/primitives.proto.
 */
export const file_thru_common_v1_primitives: GenFile = /*@__PURE__*/
  fileDesc("Ch90aHJ1L2NvbW1vbi92MS9wcmltaXRpdmVzLnByb3RvEg50aHJ1LmNvbW1vbi52MSIjCgZQdWJrZXkSGQoFdmFsdWUYASABKAxCCuBBArpIBHoCaCAiJgoJU2lnbmF0dXJlEhkKBXZhbHVlGAEgASgMQgrgQQK6SAR6AmhAIiYKCFRhUHVia2V5EhoKBXZhbHVlGAEgASgJQgvgQQK6SAVyA5gBLiIpCgtUc1NpZ25hdHVyZRIaCgV2YWx1ZRgBIAEoCUIL4EECukgFcgOYAVpCywEKEmNvbS50aHJ1LmNvbW1vbi52MUIPUHJpbWl0aXZlc1Byb3RvUAFaRGdpdGh1Yi5jb20vVW50by1MYWJzL3RocnUtbmV0L2dycGMvcGtnL3Byb3RvL3RocnUvY29tbW9uL3YxO2NvbW1vbnYxogIDVENYqgIOVGhydS5Db21tb24uVjG6AgNUSFXKAg5UaHJ1XENvbW1vblxWMeICGlRocnVcQ29tbW9uXFYxXEdQQk1ldGFkYXRh6gIQVGhydTo6Q29tbW9uOjpWMWIGcHJvdG8z", [file_buf_validate_validate, file_google_api_field_behavior]);

/**
 * Pubkey represents a 32-byte public key value.
 *
 * @generated from message thru.common.v1.Pubkey
 */
export type Pubkey = Message<"thru.common.v1.Pubkey"> & {
  /**
   * 32-byte public key buffer.
   *
   * @generated from field: bytes value = 1;
   */
  value: Uint8Array;
};

/**
 * Describes the message thru.common.v1.Pubkey.
 * Use `create(PubkeySchema)` to create a new message.
 */
export const PubkeySchema: GenMessage<Pubkey> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_primitives, 0);

/**
 * Signature represents a 64-byte signature value.
 *
 * @generated from message thru.common.v1.Signature
 */
export type Signature = Message<"thru.common.v1.Signature"> & {
  /**
   * 64-byte signature buffer.
   *
   * @generated from field: bytes value = 1;
   */
  value: Uint8Array;
};

/**
 * Describes the message thru.common.v1.Signature.
 * Use `create(SignatureSchema)` to create a new message.
 */
export const SignatureSchema: GenMessage<Signature> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_primitives, 1);

/**
 * TaPubkey represents a ta-encoded public key string (46 characters).
 *
 * @generated from message thru.common.v1.TaPubkey
 */
export type TaPubkey = Message<"thru.common.v1.TaPubkey"> & {
  /**
   * 46-character ta-encoded public key string.
   *
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message thru.common.v1.TaPubkey.
 * Use `create(TaPubkeySchema)` to create a new message.
 */
export const TaPubkeySchema: GenMessage<TaPubkey> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_primitives, 2);

/**
 * TsSignature represents a ts-encoded signature string (90 characters).
 *
 * @generated from message thru.common.v1.TsSignature
 */
export type TsSignature = Message<"thru.common.v1.TsSignature"> & {
  /**
   * 90-character ts-encoded signature string.
   *
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message thru.common.v1.TsSignature.
 * Use `create(TsSignatureSchema)` to create a new message.
 */
export const TsSignatureSchema: GenMessage<TsSignature> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_primitives, 3);

